<template>
  <b-container
    fluid="md"
    class="square-payment-access-control-error"
  >
    <b-row>
      <b-col>
        <div class="title pb-4">
          <span class="icon-container">
            <font-awesome-icon
              icon="triangle-exclamation"
              size="2x"
              class="icon"
              fixed-width
              color="red"
            />
          </span>
          <span class="h3 pr-4">
            Access Denied
          </span>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="error-message">
          <p>
            The system has detected an abnormal number of requests in a short period of time.
            This is typically an indication of fraudlent oir malicious activity, and the system has
            temporarily denied access to processing payment requests.
          </p>

          <p>
            If you are attempting to process a legitimate transaction, you will be allowed to continuing prorcessing
            again once the system detects that the abnormal payment requests have ceased. Please try again later.
          </p>
          <p>
            If you would like further information please contact the site admin.
          </p>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: 'payment-access-control-error',
  props: {
    error: {
      type: [Object, Error],
      required: true
    }
  },
  computed: {
  }
}
</script>

<style>

</style>
